import { useEffect, useState, useMemo } from 'react'
import { ContentKeylook4K } from '../model/afa'
import { useSelector } from 'react-redux'
import { eventIdSelector, languageSelector } from '../store/app/selectors'
import CatalogImage from '../assets/images/keylook/catalog_2023FW.jpg'
import app_config from '../config/app/config'
import { useParams } from 'react-router'

const useGetAfaCoverImage = () => {
  const { brandCode } = useParams<{ sportCode: string; brandCode: string }>()
  const eventId = useSelector(eventIdSelector)
  const language = useSelector(languageSelector)

  const [contentItems, setContentItems] = useState<ContentKeylook4K | undefined>(undefined)
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const getInitiativesContent = async () => {
      try {
        setIsLoading(true)
        setError(null)

        const content = await fetch(
          `${app_config.apiUrl}/content/keylook4K?eventId=${eventId}&language=${language}`,
        )

        if (!content.ok) {
          throw new Error(`HTTP error! status: ${content.status}`)
        }

        const response = (await content.json()) as ContentKeylook4K

        if (response) {
          setContentItems(response)
        } else {
          setContentItems({})
        }
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Failed to fetch content')
        setContentItems({})
      } finally {
        setIsLoading(false)
      }
    }

    if (eventId && language) {
      getInitiativesContent()
    }
  }, [eventId, language])

  const banner = useMemo(() => {
    if (!brandCode || contentItems === undefined || isLoading) {
      return ''
    }

    const matchingItem = contentItems[brandCode]

    return matchingItem || CatalogImage
  }, [brandCode, contentItems, isLoading])

  return {
    banner,
    isLoading,
    error,
  }
}

export default useGetAfaCoverImage
